var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00007 1.06332C6.27367 0.395394 5.32288 0.0246892 4.33607 0.0246582C3.81376 0.025202 3.29672 0.129031 2.81469 0.33017C2.33267 0.53131 1.89518 0.825788 1.5274 1.19666C-0.0412649 2.77199 -0.0405983 5.23599 1.52874 6.80466L6.41674 11.6927C6.53007 11.892 6.74874 12.0207 7.00007 12.0207C7.10327 12.0197 7.20479 11.9945 7.29649 11.9471C7.38819 11.8998 7.46751 11.8316 7.52807 11.748L12.4714 6.80466C14.0407 5.23532 14.0407 2.77199 12.4701 1.19399C12.1025 0.823803 11.6653 0.529923 11.1838 0.329247C10.7022 0.128571 10.1858 0.0250579 9.66407 0.0246582C8.67729 0.0248195 7.72654 0.395507 7.00007 1.06332ZM11.5274 2.13666C12.5694 3.18399 12.5701 4.81999 11.5287 5.86199L7.00007 10.3907L2.4714 5.86199C1.43007 4.81999 1.43074 3.18399 2.47007 2.13932C2.97674 1.63532 3.6394 1.35799 4.33607 1.35799C5.03274 1.35799 5.69274 1.63532 6.1954 2.13799L6.52874 2.47132C6.59059 2.53329 6.66406 2.58245 6.74494 2.61599C6.82582 2.64953 6.91251 2.66679 7.00007 2.66679C7.08763 2.66679 7.17432 2.64953 7.2552 2.61599C7.33607 2.58245 7.40954 2.53329 7.4714 2.47132L7.80474 2.13799C8.81274 1.13199 10.5207 1.13466 11.5274 2.13666Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconSmall);
export default __webpack_public_path__ + "static/media/heart-icon-small.65e116a8ad161bb39d80ffc3f12180c0.svg";
export { ForwardRef as ReactComponent };